import Cookies from 'js-cookie';

import { trackLanguageChange } from 'depop/utils/tracking';

import enMessages from 'depop/supportedLocales/en';
import itMessages from 'depop/supportedLocales/it';

const SET_LANGUAGE = '@@SET_LANGUAGE';

export function changeLanguage(language) {
  Cookies.set('language', language);
  trackLanguageChange({language});

  const { numResults: _, ...state } = window.history.state;

  window.history.replaceState(state, null, null);

  return {
    type: SET_LANGUAGE,
    value: {
      language,
      messages: {
        en: enMessages,
        it: itMessages,
      }[language],
    },
  };
}

export function localeReducer(state = {}, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {...state, ...action.value};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ../src/client/state/locale.js